import { Switch } from '@thanx/uikit/switch'
import Help from 'components/Help'
import useFlag from 'hooks/useFlag'
import { Fields as RedeemTemplate } from 'models/RedeemTemplate'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getHelp } from 'scenes/RedeemManager/Builder/ConfigurationStep/helpers'
import Restrictions from 'scenes/RedeemManager/Builder/ConfigurationStep/Restrictions'
import { generateTypeItem } from 'scenes/RedeemManager/helpers'
import CustomerSupportCard from './CustomerSupportCard'
import InstoreRedemptionCard from './InstoreRedemptionCard'
import MultipleInstoreRedemptionCard from './MultipleInstoreRedemptionCard'
import OnlineRedemptionCard from './OnlineRedemptionCard'
import RewardDetailsCard from './RewardDetailsCard'

type PropsT = {
  template: RedeemTemplate
}

const ConfigurationTab: React.FC<PropsT> = ({ template }) => {
  const typeItem = generateTypeItem(template)
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)
  const helpArticles = getHelp(typeItem?.key, freeModifierRewardsEnabled)

  const isExperience = template.type.includes('experience')

  return (
    <>
      <RewardDetailsCard template={template} typeItem={typeItem} />
      <Switch condition={typeItem?.key !== 'bonus_points'}>
        <OnlineRedemptionCard template={template} />
        <Switch
          // Fallback to showing only a single card if it's an experience reward
          condition={!isExperience}
          fallback={<InstoreRedemptionCard template={template} />}
        >
          <MultipleInstoreRedemptionCard template={template} />
        </Switch>
      </Switch>
      <CustomerSupportCard template={template} />
      <Restrictions />
      <Help
        title={I18n.t('redeem_manager.builder.steps.configuration.help.title')}
        articles={helpArticles}
      />
    </>
  )
}

export default ConfigurationTab
